export default __webpack_public_path__ + "static/media/mac.a0de41e6.svg";